import _typeof from "@babel/runtime/helpers/typeof";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * Slice the pack's shared logs down to one step — the failure record's
 * console/network refs carry a `step` cursor; the HAR marks entries with a
 * custom `_step` field and console NDJSON lines may carry `step`. Pure and
 * cheap: packs' logs are already size-guarded before these run.
 */

import { parseConsoleLine, splitNdjsonLines } from './ndjson';
function asRecord(v) {
  return v !== null && _typeof(v) === 'object' && !Array.isArray(v) ? v : null;
}
function toLine(entry) {
  var request = asRecord(entry.request);
  var response = asRecord(entry.response);
  var status = typeof (response === null || response === void 0 ? void 0 : response.status) === 'number' ? response.status : null;
  return {
    method: typeof (request === null || request === void 0 ? void 0 : request.method) === 'string' ? request.method : 'GET',
    url: typeof (request === null || request === void 0 ? void 0 : request.url) === 'string' ? request.url : '',
    status: status,
    statusText: typeof (response === null || response === void 0 ? void 0 : response.statusText) === 'string' && response.statusText !== '' ? response.statusText : '',
    failed: entry._failed === true || status !== null && status >= 400
  };
}

/** HAR entries whose `_step` matches the cursor, as displayable lines.
 * Pass step=null to get ALL entries (the untagged-pack fallback — e.g.
 * navigation-triggered requests currently carry `_step: null`). */
export function harLinesForStep(har, step) {
  var log = asRecord(har.log);
  var entries = log && Array.isArray(log.entries) ? log.entries : [];
  var out = [];
  var _iterator = _createForOfIteratorHelper(entries),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var raw = _step.value;
      var entry = asRecord(raw);
      if (!entry) continue;
      if (step !== null && entry._step !== step) continue;
      out.push(toLine(entry));
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return out;
}

/** Console NDJSON rows whose `step` field matches the cursor. Accepts the
 * already-split lines from readLogLines, or raw text. Pass step=null to
 * get ALL rows (the untagged-pack fallback). */
export function consoleEntriesForStep(input, step) {
  var lines = typeof input === 'string' ? splitNdjsonLines(input) : input;
  var out = [];
  lines.forEach(function (line, i) {
    var doc = null;
    try {
      doc = asRecord(JSON.parse(line));
    } catch (_unused) {
      return; // raw garbage has no step marker — not part of any slice
    }
    if (!doc) return;
    if (step !== null && doc.step !== step) return;
    var entry = parseConsoleLine(line, i);
    if (entry) out.push(entry);
  });
  return out;
}

/** True when any console row carries a non-null `step` — i.e. the pack
 * tags its console. Distinguishes "untagged legacy log" (fall back to ALL)
 * from "tagged log, genuinely nothing at this step" (honest empty). */
export function consoleHasStepTags(input) {
  var lines = typeof input === 'string' ? splitNdjsonLines(input) : input;
  return lines.some(function (line) {
    try {
      var doc = asRecord(JSON.parse(line));
      return Boolean(doc && doc.step !== null && doc.step !== undefined);
    } catch (_unused2) {
      return false;
    }
  });
}

/** True when any HAR entry carries a non-null `_step`. */
export function harHasStepTags(har) {
  var log = asRecord(har.log);
  var entries = log && Array.isArray(log.entries) ? log.entries : [];
  return entries.some(function (raw) {
    var entry = asRecord(raw);
    return Boolean(entry && entry._step !== null && entry._step !== undefined);
  });
}